import { render, staticRenderFns } from "./ProjectRegistration.vue?vue&type=template&id=1e65ed10&scoped=true"
import script from "./ProjectRegistration.vue?vue&type=script&lang=js"
export * from "./ProjectRegistration.vue?vue&type=script&lang=js"
import style0 from "./ProjectRegistration.vue?vue&type=style&index=0&id=1e65ed10&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e65ed10",
  null
  
)

export default component.exports